import { createApp } from "vue";
import { Dropdown } from "bootstrap";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import App from "./App.vue";
import router, { refreshPermissionsThrottled } from "./router";
import BootstrapVueNext from "bootstrap-vue-next";
import VueApexCharts from "vue3-apexcharts";
import { QuillEditor } from '@vueup/vue-quill'
import Vue3Prism from 'vue3-prism/lib/Vue3Prism.common.js'

import { globalHelper } from './utils/helpers'


import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ToastComponent from 'primevue/toast';
import { useToast } from 'primevue/usetoast';
import Vue3EasyDataTable from 'vue3-easy-data-table';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Import specific icons
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { faFacebook } from '@fortawesome/free-brands-svg-icons'
import VueGoodTablePlugin from 'vue-good-table-next';
import Swal from 'sweetalert2'

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "swiper/css";
import "swiper/css/bundle";
import 'flatpickr/dist/flatpickr.css';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import '@vueup/vue-quill/dist/vue-quill.bubble.css';
import "vue3-prism/lib/Vue3Prism.css"
import 'vue3-easy-data-table/dist/style.css';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import 'sweetalert2/src/sweetalert2.scss'

import 'vue-select/dist/vue-select.css';


import "./assets/custom.scss";
import { startSessionHandoff } from "./utils/sessionHandoff";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import 'sweetalert2/dist/sweetalert2.min.css'
import PaginatorContent from "@/components/PaginatorContent.vue";

import vSelect from 'vue-select'
import stateStore from "./utils/store";


// Add icons to the library
library.add(faUserSecret, faFacebook)


const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App)
app.use(pinia);

// "Login as" links (?login_code= / ?staff_token=), see utils/sessionHandoff.ts.
// Must run before app.use(router) starts the first navigation.
startSessionHandoff();

app.use(router);
app.use(VueApexCharts);
app.use(BootstrapVueNext);
app.use(PrimeVue);
app.use(ToastService);

app.use(Toast);
app.use(VueGoodTablePlugin);




// Auth/permission guards live in router/index.ts.
router.afterEach(() => {
  const stateStoreInstance = stateStore;
  if (stateStoreInstance.open) {
    stateStoreInstance.onChange();
  }
});

// Register Toast globally
app.component('Toast', ToastComponent);
app.component('QuillEditor', QuillEditor)
.use(Vue3Prism)

app.component('EasyDataTable', Vue3EasyDataTable);
app.component('font-awesome-icon', FontAwesomeIcon)
app.component("PaginatorContent",   PaginatorContent);

app.component('v-select', vSelect)
// Add global function
app.config.globalProperties.$showSuccessToast = (message: string) => {
  const toast = useToast();
  toast.add({
    severity: 'success',
    summary: 'Success',
    detail: message,
    life: 3000,
  });
};

app.config.globalProperties.$showErrorToast = (message: string) => {
  const toast = useToast();
  toast.add({
    severity: 'error',
    summary: 'Erreur',
    detail: message,
    life: 3000,
  });
};

app.config.globalProperties.$globalHelper = globalHelper

app.mount("#app");

// Global: initialize all Bootstrap dropdowns with Popper strategy:'fixed'
// so they render above any overflow:auto/scroll container (tables, vgt-responsive…)
const initFixedDropdowns = () => {
  document.querySelectorAll<HTMLElement>('[data-bs-toggle="dropdown"]').forEach((el) => {
    if (Dropdown.getInstance(el)) return;
    new Dropdown(el, {
      popperConfig: (defaultConfig: any) => ({ ...defaultConfig, strategy: "fixed" }),
    });
  });
};
initFixedDropdowns();
let _dropdownDebounce: ReturnType<typeof setTimeout>;
new MutationObserver(() => {
  clearTimeout(_dropdownDebounce);
  _dropdownDebounce = setTimeout(initFixedDropdowns, 80);
}).observe(document.body, { childList: true, subtree: true });

// Refresh permissions when the user comes back to the tab (throttled). No timer
// polling: with many users, idle background tabs would otherwise load the API.
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") refreshPermissionsThrottled();
});
